import { TenantAppShell } from '@/app/TenantAppShell';

import './App.css';
import styles from './App.module.css';
import { router } from './App.router';

function App() {
	return <TenantAppShell router={router} extraClassNames={[styles['App']]} />;
}

export default App;
